import { Component, OnInit } from '@angular/core';

import { BbTableService, BbTableSelectOption, TableRow } from '../../../services/bb-table.service';
import { Role } from '../../../interfaces/user';
import { Publication } from '../../../interfaces/publication';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { PublicationService } from '../../../services/publication.service';
import { AbstractListComponent } from '../../shared/abstract-list.component';

@Component({
	selector: 'upload-credentials-list',
	templateUrl: './upload-credentials-list.component.html',
	styleUrls: ['./upload-credentials-list.component.scss'],
	providers: [BbTableService]
})

export class UploadCredentialsListComponent extends AbstractListComponent implements OnInit {
	filterConfig: BbFilterConfiguration;
	putRight = false;

	constructor(
		protected publicationService: PublicationService,
		protected bbTableService: BbTableService
	) {
		super(bbTableService);

		this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight);

		this.listConfiguration = {
			name: 'uploadcredentials',
			basePath: '/publication/upload-credentials/'
		};

		this.filterConfig = {
			search: false
		};
	}

	ngOnInit() {

		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (
			row && row.data && row.data.id
		) {
			this.router.navigate([this.listConfiguration.basePath, row.data.id]);
		}
	}

	deleteSingle(uploadcredentials: any) {
		const dialogContents = this.translate.instant('DELETE_ENTITY_CONFIRM', {
			entity: this.translate.instant('UPLOAD_CREDENTIALS').toLowerCase()
		});

		super.deleteSingle(uploadcredentials, dialogContents);
	}
}
